import { CircleUser } from 'lucide-react'
import t2VectorImg from '@shared/assets/2preview_Vector_x2.png'
import t4LineImg from '@shared/assets/template4/line.png'
import t4Line2Img from '@shared/assets/template4/line2.png'


/**
 * Pure display component for review blocks.
 * Handles template 1/2/3 styles.
 * No editing UI. Safe to copy to frontend (needs template CSS + t2VectorImg asset).
 */
export function ReviewView({ name, title, content, useTemplate3Style, templateId, isMobile, mode, imagePosition }) {
  if (!name && !content) return null

  const isTemplate2 = templateId === 2
  const isTemplate4 = templateId === 4
  const isTemplate5 = templateId === 5
  const textSize = (mode === 'mobile' || isMobile) ? 'text-sm'
    : mode === 'tablet' ? 'text-sm'
      : 'text-base'

  const isMobileView = mode === 'mobile' || isMobile
  const vectorImgScaleClass = isMobileView ? '' : 'desktop'

  if (isTemplate5) {
    return (
      <div className="tpl5-review h-full flex flex-col justify-start">
        {name && (
          <div className="tpl5-review-name" dangerouslySetInnerHTML={{ __html: name }} />
        )}
        {title && (
          <div className="tpl5-review-title" dangerouslySetInnerHTML={{ __html: title }} />
        )}
        {content && (
          <div className="tpl5-review-content" dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    )
  }

  if (isTemplate4) {
    const t4AlignClass = imagePosition === 'left'
      ? 'ml-auto mr-0'
      : imagePosition === 'right'
        ? 'ml-0 mr-auto'
        : 'mx-auto'
    return (
      <div className={`w-4/5 px-2 py-1 ${t4AlignClass}`}>
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full flex items-center justify-center shrink-0">
            <CircleUser className="w-6 h-6" />
          </div>
          {name && (
            <div className={`max-w-full flex-1 min-w-0 font-semibold ${textSize}`}>
              <span dangerouslySetInnerHTML={{ __html: name }} />
            </div>
          )}
        </div>
        <img src={imagePosition === 'right' ? t4Line2Img : t4LineImg} alt="" className="w-full my-2" />
        {content && (
          <div
            className={`leading-relaxed ${textSize}`}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    )
  }

  if (isTemplate2) {
    const t2AlignClass = imagePosition === 'left'
      ? 'ml-auto mr-0'
      : imagePosition === 'right'
        ? 'ml-0 mr-auto'
        : 'mx-auto'
    return (
      <div className={`t2-review ${isMobileView ? 'mx-auto' : t2AlignClass}`} style={isMobileView ? undefined : { margin: '16px' }}>
        <div className="t2-review-inner">
          <div className="t2-review-top">
            <CircleUser className="t2-review-icons" />
            <div className="t2-review-name-block">
              {name && <span dangerouslySetInnerHTML={{ __html: name }} />}
            </div>
          </div>
          <div className="t2-review-vector">
            <img src={t2VectorImg} alt="" className={`t2-review-image ${vectorImgScaleClass}`} />
          </div>
          <div className="t2-review-content-block">
            {content && (
              <div
                className="w-full h-full min-h-0 bg-transparent overflow-auto"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </div>
        </div>
      </div>
    )
  }

  const isTemplate1Or3 = templateId === 1 || templateId === 3
  const textAlignRight = imagePosition === 'left'
  const wrapClass = isTemplate1Or3 && imagePosition
    ? `w-4/5 ${textAlignRight ? 'ml-auto mr-0' : 'mr-auto ml-0'}`
    : undefined
  return (
    <div
      className={[
        wrapClass,
        isTemplate1Or3
          ? 'px-2 py-1'
          : useTemplate3Style
            ? 'tpl3-review-card p-6'
            : 'bg-[#f9fafb] rounded-[8px] shadow-sm hover:shadow-md transition-shadow border-l-[8px] border-[#E20020] p-6'
      ].filter(Boolean).join(' ')}
      style={isTemplate1Or3 ? undefined : { margin: '1rem' }}
    >
      <div className="flex items-center gap-4 mb-4">
        <div className={
          useTemplate3Style
            ? 'tpl3-review-avatar rounded-full flex items-center justify-center shrink-0 w-[26px] h-[26px]'
            : 'w-12 h-12 bg-[#907654]/20 rounded-full flex items-center justify-center shrink-0'
        }>
          <CircleUser className={useTemplate3Style ? 'w-3.5 h-3.5' : 'w-6 h-6 text-[#907654]'} />
        </div>
        {name && (
          <div className={`max-w-full flex-1 min-w-0 ${useTemplate3Style ? 'tpl3-review-name' : `text-[#1B1A1E] font-semibold ${textSize}`}`}>
            <span dangerouslySetInnerHTML={{ __html: name }} />
          </div>
        )}
      </div>
      {content && (
        <div
          className={`leading-relaxed ${useTemplate3Style ? 'tpl3-review-content' : `text-[#5a5550] leading-relaxed ${textSize}`}`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  )
}
